import { Table, Button } from 'antd';
import React, { Component } from 'react';
import { columns1 } from './data';

class index extends Component {
    render() {
        const { data, print, onExport } = this.props;
        return (
            <div>
                <Table
                    columns={columns1(print)}
                    dataSource={data.data1}
                    size="middle"
                    bordered
                    id="table5_10_1"
                    pagination={false}
                    className="content"
                    scroll={print ? {} : { x: 3350, y: false }}
                    rowKey={v => v.sort}
                />
                {print ? null : <Button
                    className='export-btn'
                    type="primary"
                    onClick={() => onExport('table5_10_1')}
                    loading={print}
                >导出Excel</Button>}
            </div>

        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-10/Table5_10_1.js